import { ref } from 'vue'

/**
 * A transient, app-level notice — a non-blocking signal from the HTTP layer that
 * isn't tied to a specific component, shown briefly by App.vue and auto-cleared.
 *
 * Currently used for the "couldn't verify Discogs availability" warning: when a
 * sale/reserve/channel-change of a Discogs-listed record proceeds while Discogs is
 * unreachable, the backend returns an `X-Discogs-Unverified` header and the api
 * client raises this notice so staff know to double-check the item didn't already
 * sell on Discogs. The value is an i18n code under `warnings.*`.
 */
export const actionNotice = ref<string | null>(null)

let timer: ReturnType<typeof setTimeout> | undefined

export function setActionNotice(code: string, ttlMs = 8000): void {
  actionNotice.value = code
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    actionNotice.value = null
  }, ttlMs)
}

export function clearActionNotice(): void {
  if (timer) clearTimeout(timer)
  actionNotice.value = null
}
